<div class="mb-27">
    <h4 class="f-wb">{{ 'profiles.view.voter-voice.label' | translate | titlecase }}</h4>
</div>
<p-table [showGridlines]="true" *ngIf="voterVoices?.length> 0" [lazy]="false" [value]="voterVoices">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="mct-hide-lt-md" >
            <th [pSortableColumn]="'Government'">
                {{ 'profiles.view.voter-voice.government' | translate | titlecase }}
                <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'OfficialName'">
                {{ 'profiles.view.voter-voice.official-name' | translate | titlecase }}
                <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'OfficialParty'">
                {{ 'profiles.view.voter-voice.official-party' | translate | titlecase }}
                <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'OfficialTitle'">
                {{ 'profiles.view.voter-voice.official-title' | translate | titlecase }}
                <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'OfficeElectedBody'">
                {{ 'profiles.view.voter-voice.official-elected-body' | translate | titlecase }}
                <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'OfficeElectoralConstituency'">
                {{ 'profiles.view.voter-voice.official-electoral-constituency' | translate | titlecase }}
                <p-sortIcon></p-sortIcon>
            </th>
        </tr>
        <tr class="mct-hide-gt-sm" >
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-voterVoice>
        <tr class="mct-hide-lt-md" >
            <td>{{ voterVoice.Government }}</td>
            <td>{{ voterVoice.OfficialName }}</td>
            <td>{{ voterVoice.OfficialParty }}</td>
            <td>{{ voterVoice.OfficialTitle }}</td>
            <td>{{ voterVoice.OfficeElectedBody }}</td>
            <td>{{ voterVoice.OfficeElectoralConstituency }}</td>
        </tr>
        <tr class="mct-hide-gt-sm" >
            <td>
                <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
                    <div class="light-text">{{ 'profiles.view.voter-voice.government' | translate | titlecase }}</div>
                    <div>
                        {{ voterVoice.Government }}
                    </div>
                </div>
                <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
                    <div class="light-text">{{ 'profiles.view.voter-voice.official-name' | translate | titlecase }}
                    </div>
                    <div>
                        {{ voterVoice.OfficialName }}
                    </div>
                </div>
                <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
                    <div class="light-text">{{ 'profiles.view.voter-voice.official-party' | translate | titlecase }}
                    </div>
                    <div>
                        {{ voterVoice.OfficialParty }}
                    </div>
                </div>
                <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
                    <div class="light-text">{{ 'profiles.view.voter-voice.official-title' | translate | titlecase }}
                    </div>
                    <div>
                        {{ voterVoice.OfficialTitle }}
                    </div>
                </div>
                <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
                    <div class="light-text">{{ 'profiles.view.voter-voice.official-elected-body' | translate | titlecase
                        }}</div>
                    <div>
                        {{ voterVoice.OfficeElectedBody }}
                    </div>
                </div>
                <div   class="mb-6 mct-flex mct-col mct-justify-start mct-items-stretch">
                    <div class="light-text">{{ 'profiles.view.voter-voice.official-electoral-constituency' | translate |
                        titlecase }}</div>
                    <div>
                        {{ voterVoice.OfficeElectoralConstituency }}
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
